import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import Enums from "@/enums";

export default function SiteRoleAccessibility(props) {
  const canEdit = props.adminPerms?.includes(Enums.ROLE_PERMS.EditSite)
    || props.adminPerms?.includes(Enums.ROLE_PERMS.EditRoles)
    || props.adminPerms?.includes(Enums.ROLE_PERMS.CompanyAdmin)
    || props.adminPerms?.includes(Enums.ROLE_PERMS.SystemAdmin);

  function isRoleSiteChecked(roleId) {
    return props.roleSites?.some(
      (rs) => rs.key === roleId && rs.value === props.activeSite.id
    );
  }

  return (
    <div className="tableWrapper factTable horizontal siteRolesTable scrollable">
      <table>
        <caption>
          <span className="title">{props.subEntityTypeName || "Site"} / Roles</span>
        </caption>
        <thead>
          <tr>
            <th>Role</th>
            <th>Access</th>
          </tr>
        </thead>
        <tbody>
          {props.roles
            ? props.roles.map((role) => (
              <tr key={"siteRole" + role.key}>
                <td>{role.value}</td>
                <td
                  onClick={() => {
                    if (canEdit) props.toggleSiteRole(role.key);
                  }}
                  className="actions"
                >
                  {isRoleSiteChecked(role.key) ? (
                    <MdCheckBox className={`checkbox checked actionIcon${canEdit ? "" : " disabled"}`} />
                  ) : (
                    <MdCheckBoxOutlineBlank className={`checkbox unchecked actionIcon${canEdit ? "" : " disabled"}`} />
                  )}
                </td>
              </tr>
            ))
            : null}
        </tbody>
      </table>
    </div>
  );
}
